export type OrderStatusGroupId =
  | "unpaid"
  | "paid"
  | "in_progress"
  | "delivered"
  | "cancelled";

export interface OrderStatusGroupConfig {
  id: OrderStatusGroupId;
  label: string;
  wooStatuses: string[];
  sortOrder: number;
  visible: boolean;
}

export const ORDER_STATUS_GROUPS: OrderStatusGroupConfig[] = [
  {
    id: "unpaid",
    label: "Não pagos",
    wooStatuses: ["pending", "on-hold", "failed"],
    sortOrder: 1,
    visible: true,
  },
  {
    id: "paid",
    label: "Pagos",
    wooStatuses: ["processing", "completed"],
    sortOrder: 2,
    visible: true,
  },
  {
    id: "in_progress",
    label: "A caminho",
    wooStatuses: ["processing"],
    sortOrder: 3,
    visible: false,
  },
  {
    id: "delivered",
    label: "Entregues",
    wooStatuses: ["completed"],
    sortOrder: 4,
    visible: false,
  },
  {
    id: "cancelled",
    label: "Cancelados",
    wooStatuses: ["cancelled", "refunded"],
    sortOrder: 5,
    visible: false,
  },
];

export const VISIBLE_ORDER_STATUS_GROUPS = ORDER_STATUS_GROUPS.filter(
  (group) => group.visible,
);

export function getOrderStatusGroupId(
  status: string,
  needsPayment?: boolean,
): OrderStatusGroupId {
  const cancelledGroup = ORDER_STATUS_GROUPS.find((group) => group.id === "cancelled");
  if (cancelledGroup?.wooStatuses.includes(status)) {
    return "cancelled";
  }
  if (needsPayment) return "unpaid";
  const match = ORDER_STATUS_GROUPS.find((group) =>
    group.wooStatuses.includes(status),
  );
  return match?.id ?? "paid";
}

export function getOrderStatusGroupLabel(groupId: OrderStatusGroupId): string {
  return (
    ORDER_STATUS_GROUPS.find((group) => group.id === groupId)?.label ?? groupId
  );
}
